import { render, staticRenderFns } from "./estudante-relatorio.vue?vue&type=template&id=5895af25&"
import script from "./estudante-relatorio.vue?vue&type=script&lang=js&"
export * from "./estudante-relatorio.vue?vue&type=script&lang=js&"
import style0 from "./estudante-relatorio.vue?vue&type=style&index=0&id=5895af25&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports